import React from "react";

import { CarrierWarningAlert } from "./CarrierWarningAlert";
import { CarrierOverLimitAlert } from "./CarrierOverLimitAlert";

import type { SendRfpCarrier } from "./api/types";

const DEFAULT_OVER_LIMIT_MESSAGE =
  "A selected carrier does not support API submissions for this group size. Unselect it or use offline submission.";

interface SubmitBlockingAlertsProps {
  visible: boolean;
  showCarrierWarning: boolean;
  selectedCarriersOverLimit: SendRfpCarrier[];
  onEditCarriers: () => void;
}

// The Review-step alerts that block submit: a carrier missing a sales-rep email,
// or a selected carrier whose group exceeds its API submission limit (PB-690).
// Both point the user back to the carriers step.
export function SubmitBlockingAlerts({
  visible,
  showCarrierWarning,
  selectedCarriersOverLimit,
  onEditCarriers,
}: SubmitBlockingAlertsProps): React.JSX.Element | null {
  if (!visible) return null;
  return (
    <>
      {showCarrierWarning && (
        <CarrierWarningAlert onEditCarriers={onEditCarriers} />
      )}
      {selectedCarriersOverLimit.length > 0 && (
        <CarrierOverLimitAlert
          message={
            selectedCarriersOverLimit[0].restrictionMessage ??
            DEFAULT_OVER_LIMIT_MESSAGE
          }
          onEditCarriers={onEditCarriers}
        />
      )}
    </>
  );
}
